export const FETCH_COUNTRY_SITES = "FETCH_COUNTRY_SITES"
export const FETCH_COUNTRY_SITES_REQUEST = "FETCH_COUNTRY_SITES_REQUEST"
export const FETCH_COUNTRY_SITES_SUCCESS = "FETCH_COUNTRY_SITES_SUCCESS"
export const FETCH_COUNTRY_SITES_FAILURE = "FETCH_COUNTRY_SITES_FAILURE"
export const RESET_COUNTRY_SITE_SEARCH = "RESET_COUNTRY_SITE_SEARCH"

